import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BetoCarrero } from 'src/app/model/turismo/beto-carrero.model';
import { Util } from 'src/app/services';
import { BetoCarreroService } from 'src/app/services/turismo/beto-carrero.service';
import { ModalComponent } from '../../modal/modal.component';

@Component({
  selector: 'app-ingressos-card',
  standalone: false,
  templateUrl: './ingressos-card.component.html',
  styleUrl: './ingressos-card.component.scss'
})
export class IngressosCardComponent implements OnInit {
  @Input() beto: BetoCarrero;
  @Input() statusOrcamento: number;
  @Input() liberaVoucher: boolean;
  @Input() termometroValido: boolean;
  @Input() cardSimplificado: boolean = false;
  @Input() betoId: number = null;
  @Input() idadeInvalida: boolean = false;
  @Input() cardItem: any;

  @Output() verificaIdadeValida: EventEmitter<void> = new EventEmitter<void>();
  @Output() imprimirVoucherEmitter: EventEmitter<BetoCarrero> = new EventEmitter<BetoCarrero>();
  @Output() atualizarBetoEmitter: EventEmitter<BetoCarrero> = new EventEmitter<BetoCarrero>();
  @Output() carregarObjetoEmitter: EventEmitter<number> = new EventEmitter<number>();

  @ViewChild("modalReserva") modalReserva: ModalComponent;
  @ViewChild("modalCancela") modalCancela: ModalComponent;
  @ViewChild("modalDetalhes") modalDetalhes: ModalComponent;

  mensagemErroBeto: string = "";
  mensagemSucessoBeto: string = "";

  carregando: boolean = false;

  constructor(
    private betoCarreroService: BetoCarreroService,
    private utilService: Util
  ) { }

  ngOnInit(): void {
    if (this.cardSimplificado) {
      if(this.cardItem != null && this.cardItem != undefined){
        this.beto = this.cardItem;
        this.carregando = false;
      } else if (this.betoId) {
        this.buscarBetoPorId();
      }
    } else if (this.betoId) {
      this.buscarBetoPorId();
    }
  }

  buscarBetoPorId() {
    this.carregando = true;
    this.betoCarreroService.buscarIngressoPorId(this.betoId).subscribe(
      dados => {
        this.beto = dados;
        this.carregando = false;
      },
      erro => {
        this.mensagemErroBeto = this.utilService.errorHandler(erro);
        this.carregando = false;
      });
  }

  atualizarBeto(beto: BetoCarrero) {
    this.beto = beto;
    this.carregarObjetoEmitter.emit(this.beto.ReservaId);
  }

  removerBetoCarrero(betoCarrero) {
    if (confirm("Confirmar exclusão do serviço?")) {

      if (this.termometroValido) {
        alert(this.utilService.fazerTraducao("Necessário retornar o valor do termômetro para padrão antes de remover esse item."));
        return;
      }

      this.betoCarreroService.removerIngresso(betoCarrero.Id).subscribe(
        dados => {
          this.mensagemSucessoBeto = `Ingresso ${dados.Id} removido com sucesso!`;
          this.carregarObjetoEmitter.emit(this.beto.ReservaId);
        },
        erro => {
          this.mensagemErroBeto = this.utilService.errorHandler(erro);
        });
    }
  }

  validaSePodeReservar() {
    this.verificaIdadeValida.emit();
    if (this.idadeInvalida) {
      this.mensagemErroBeto = this.utilService.fazerTraducao('Verifique a Idade dos passageiros.');
      return;
    } else {
      this.modalReserva.open();
    }
  }
}
